import styled, { css } from 'styled-components';
import { media } from 'core/layout';
import { blockHeight, padding } from '../../../constants';

const applyPadding = (props) => {
  const { compact } = props;
  const pad = padding(props);
  return css`
    padding: ${pad}px ${pad}px ${pad * (compact ? 1 : 1.5)}px;
  `;
};

const StyledContent = styled.section`
  min-height: ${blockHeight}px;
  position: relative;
  ${applyPadding};

  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > header > * {
    margin-bottom: 0;
  }

  & > p {
    margin-bottom: 0 !important;

    &:empty {
      display: none;
    }
  }

  ${media.tabletSmall`
    min-height: 0;
    width: 100%;
  `};
`;

export default StyledContent;



// WEBPACK FOOTER //
// ./src/elements/Card/components/Content/styled/StyledContent.js